<template>
    <Sidebar />

    <Content class="analytics-content analytics-big-box">
        <div class="inner inner-box">
            <div style="height:calc(100% - 126px)">
                <AnalyticsHeader v-if="$store.state.user_data" :key="any_head_key" ref="analytics_header"/>
                <Scrollbar id="js-scrollbar-content">

                    <div class="head-info">
                        <div class="title">
                            <h2>
                                <span>Social</span>
                                <p class="small-text">Insights available 7 days after content posted. Data updated daily after.&nbsp;
                                <div class="link" v-if="otherTag.hastags.length > 0 ||  otherTag.instagram_mentions.length > 0 || otherTag.tiktok_mentions.length > 0"
                                    @click="goSetting()">Update content settings.</div>
                                </p>
                            </h2>
                        </div>

                        <div class="select-line" v-if="had_m_ht">
                            <div class="select-tags" >
                                <!-- v-if="tags.length > 0" -->
                                <div class="tags" >
                                    <Checkbox size="small" :key="'all'" :label_text="'All'"
                                        :checked="selected_tags.length === 0" @click="selectAll" />
                                    <Checkbox size="small" v-if="!is_link_only" :key="'In Storefront'" :label_text="'In Storefront'" :checked="selected_tags.filter((t) => t.id === -2).length !== 0"
                                        @click="selectTag({ id: -2, text: `In Storefront` })"/>
                                    <Checkbox size="small" v-for="(v, k) in tags" :key="k" :label_text="v.text"
                                        :checked="selected_tags.filter((t) => t.id === v.id).length !== 0"
                                        @click="selectTag(v)" />
                                </div>
                                <Button class="new-btn" color="dark-blue" size="24" @click="openTags(false, $event)"
                                    v-if="tags.length > 0 && permission_creator.addOrEditContentTag.permission"><svg-icon name="plus" /></Button>
                                <i class="open-popup" @click="openTags(true, $event)" v-if="tags.length > 0 && permission_creator.addOrEditContentTag.permission"><svg-icon
                                        name="edit" /></i>

                                <DropdownHashtag 
                                    :tags="tags" :otherTag="otherTag" :selected_tags="selected_tags"
                                    @select-all="selectAll" @select-tag="selectTag" ref="pop"
                                    :drop_css="drop_css" :is_anchor_post="true"/>
                            </div>

                        </div>
                    </div>

                    <div class="main">
                        <div class="content-box" v-if="!chart_loading" :key="st_key">
                            <ContentSummary :chart_head="chart_head1" :is_empty="!had_m_ht" v-if="tiktok_posts_count">
                                <template #head>
                                    <header>
                                        <h3><svg-icon name="tiktok-pure" />TikTok ({{ tiktok_posts_count }} total)</h3>
                                    </header>
                                </template>
                            </ContentSummary>
                            <ContentSummary :chart_head="chart_head2" :is_empty="!had_m_ht" v-if="instagram_posts_count">
                                <template #head>
                                    <header>
                                        <h3><svg-icon name="instagram" />Instagram ({{ instagram_posts_count }} total)</h3>
                                        <p><strong>In-Feed ({{ instagram_feed_count }} total)</strong></p>
                                    </header>
                                </template>
                            </ContentSummary>
                            <ContentSummary :chart_head="chart_head3" :is_empty="!had_m_ht" v-if="story_count">
                                <template #head>
                                    <header>
                                        <p><strong>Stories ({{ story_count }} total)</strong></p>
                                        <p><span>Story media metrics are available 24 hours after a Story first runs.  Hashtags and mentions must be added before a Story runs to capture the metrics associated with that applicable Story.</span></p>
                                    </header>
                                </template>
                            </ContentSummary>

                            <TopBrandPost v-if="!top_post.loading" :title="''" :posts="top_post.data" :posts_value="top_post" @clickPost="clickPost"
                                @updateSort="updateSort" @selectTop="selectTopNavi" :had_tag="false"
                                :had_navi="now_tab === 0" :now_tab="top_post.top_menu_index === 0 ? 1 : 0"
                                @changeIgTag="changeIgTag" :creator_show="true" :is_click_by_user="is_click_by_user" @findStop="is_click_by_user=true"/>
                        </div>
                    </div>
                
                </Scrollbar>
            </div>   
        </div>
    </Content>

</template>

<script>
import Sidebar from '@/components/Sidebar.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import AnalyticsHeader from '@/components/analytics/AnalyticsHeader.vue';
import Button from '@/components/ui/Button.vue';
import Content from '@/components/ui/Content.vue';
import SvgIcon from '@/components/ui/SvgIcon.vue';
import ContentSummary from '@/components/summary/ContentSummary.vue';
import formatMoney from '@/utils/formatMoney';
import moment from 'moment';
import TopBrandPost from '@/components/TopBrandPost.vue';
import Navi from '@/components/Navi.vue';
import Dropdown from '@/components/ui/Dropdown.vue';
import Audience from '@/components/Audience.vue';
import Loading from '@/components/ui/Loading.vue';
import Modal from '@/components/ui/Modal.vue';
import Hashtag from '@/components/Hashtag.vue';
import Checkbox from '@/components/ui/Checkbox.vue';
import DropdownHashtag from '@/components/DropdownHashtag.vue';
import ImportUrl from '@/components/ImportUrl.vue';
import { HandleNum, HandleName, HandleNumSpec, fakeCreator, handleMaxMinFun } from '@/utils/SwitchFun';
import { get_all_post_data, SwitchTopSort, handleSelectText, handleSelectArray } from '@/utils/ContentSwitchFun.js';

export default {
    name: 'Analytics - Content',

    data() {
        return {
            start_date: moment().add(-30, 'days').toDate(),
            end_date: moment().add(-1, 'days').toDate(),
            sticker_tab: [
                { name: 'All Platforms', index: 0 },
                { name: 'TikTok', index: 1, svg: 'tiktok-pure' },
                { name: 'Instagram', index: 2, svg: 'instagram' },
            ],
            now_tab: 0,
            top_post: get_all_post_data,
            // tag_text: '',
            chart_head: [
                { name: 'Views', value: '---', field: 'total_view', trend: 'page_views_trend', show: true, content: `Total views for the creator’s matched posts. <br><br>TikTok views are counted when a video plays, including autoplays and loops. <br><br>Instagram views are counted when a video is watched for 3+ seconds and does not include video loops.` },
                { name: 'TikTok Engagement', value: '---', field: 'tiktok_total_engagement', trend: 'page_views_trend', show: true, content: `Number of likes, comments, saves, and shares, compared to overall reach, for the creator's matched posts.` },
                { name: 'Instagram Engagement', value: '---', field: 'instagram_total_engagement', trend: 'page_views_trend', show: true, content: `Total number of reactions, comments, and saves of a matched post / number of followers. This counts all reactions and comments, including ones that were removed or deleted.` },
                { name: 'Posts', value: '---', field: 'total_posts', trend: 'page_views_trend', show: true, content: `Total number of matched posts by this creator.` },
            ],
            chart_head1: [],
            chart_head2: [],
            chart_head3: [],
            chart_loading: true,
            default_text: 'Tags: All',
            tags: [],
            otherTag: {
                hastags: [],
                instagram_mentions:[],
                tiktok_mentions:[],
            },
            selected_tags: [],
            is_show_import_modal: false,
            soc_tab: 1,
            tiktok_posts_count: 0,
            instagram_posts_count: 0,
            instagram_feed_count: 0,
            story_count: 0,
            st_key: 0,
            any_head_key:0,
            had_m_ht: true,
            is_end: false,
            is_click_by_user:false,
            drop_css: '',
            selected_creator_tags: [],
            creator_tag_operation_type: 'or',
        }
    },

    components: {
        Sidebar,
        Scrollbar,
        AnalyticsHeader,
        Button,
        Content,
        SvgIcon,
        ContentSummary,
        TopBrandPost,
        Navi,
        Dropdown,
        Audience,
        Loading,
        Modal,
        Hashtag,
        Checkbox,
        DropdownHashtag,
        ImportUrl,
    },

    watch: {
        '$store.state.user_data.merchant_account_id': function (val) {
            console.log('$store.state.user_data.merchant_account_id', val)
            this.startFun();
            this.getTags();
        },

    },

    computed: {
        socisl_post_type() {
            //video reel post story
            if (this.top_post.top_menu_index === 1) {
                if (this.top_post.ig_post_type === 0) {
                    return 'post'
                } else if (this.top_post.ig_post_type === 1) {
                    return 'reel'
                } else {
                    return 'story'
                }
            } else {
                return 'video'
            }
        },
        permission_creator(){
            return this.$store.state.user_data?.permission_list?.creatorManagement;
        },
        is_link_only() {
            return this.$store.state.user_data?.merchant_account?.platform_type === 'linkonly';
        },
    },


    methods: {
        formatMoney: formatMoney,
        handleSelectText: handleSelectText,

        openTags(is_drop, e) {
            this.drop_css = 'left: ' + e.target.offsetLeft + 'px; transform: translateX(-50%);';
            this.$refs.pop.open(is_drop);
        },

        handle_post_type(){
            //video reel post story
            // console.log('this.top_post.ig_post_type',this.top_post.ig_post_type)
            if (this.top_post.top_menu_index === 1) {
                if (this.top_post.ig_post_type === 0) {
                    return 'post'
                } else if (this.top_post.ig_post_type === 1) {
                    return 'reel'
                } else {
                    return 'story'
                }
            } else {
                return 'video'
            }
        },

        updateDate(obj) {
            this.start_date = moment(obj.start_date).format('YYYY-MM-DD');
            this.end_date = moment(obj.end_date).format('YYYY-MM-DD');
            this.callApi();
        },

        getTags() {
            if (this.$store.state.user_data) {
                this.$ajax(`creator/get-social-post-filter`, {
                    method: 'get',
                }).then(res => {
                    const data = res.data.data;
                    if (!data) return;
                    this.tags = data.social_post_tag_texts;
                    this.otherTag.hastags = data.social_post_hashtag_texts;
                    this.otherTag.instagram_mentions= data.social_post_instagram_mention_texts;
                    this.otherTag.tiktok_mentions=data.social_post_tiktok_mention_texts;
                    this.top_post.tag_select = this.tags;

                    this.had_m_ht = (data.social_post_hashtag_texts.length === 0 && data.social_post_instagram_mention_texts.length === 0 && data.social_post_tiktok_mention_texts.length === 0) ? false : true;

                });
            }
        },

        changeIgTag(index,is_click_by_user) {
            this.is_click_by_user=is_click_by_user;
            this.top_post.ig_post_type = index;
            this.getTop();
        },

        updateTag(tag) {
            // console.log(arr)
            // this.selected_tags = handleSelectArray(arr, this.selected_tags, this.tags);
            if (this.selected_tags.findIndex(o => o.id === tag.id) === -1) {
                this.selected_tags.push(tag);
            } else {
                this.selected_tags = this.selected_tags.filter(o => o.id !== tag.id);
            }

            if (this.selected_tags.length === 0) {
                this.default_text = 'Tags: All';
            } else {
                this.default_text = 'Tags: ';
                this.selected_tags.forEach((v, k) => {
                    this.default_text += v.text + (k === this.selected_tags.length - 1 ? '' : ', ');
                });
            }
            this.callApi();
        },

        selectTopNavi(index,is_click_by_user) {
            this.top_post.top_menu_index = index;
            this.is_click_by_user=is_click_by_user;
            this.getTop();
        },

        updateSort(id) {
            let getVal = SwitchTopSort(id.id);
            this.top_post.sort.sort_key = getVal.key;
            this.top_post.sort.sort_val = getVal.val;
            this.top_post.sort_index = this.top_post.sort_select.findIndex(obj => obj.id === id.id);
            this.top_post.drop_key += 1;
            this.getTop();
        },

        getTop(is_next = false) {

            if (is_next) {
                this.top_post.sort.page += 1;
                this.top_post.next_loading = true;
            } else {
                this.top_post.sort.page = 1;
                this.top_post.loading = true;
            }

            let sp = this.top_post.top_menu_index === 0 ? 'tikTok' : 'instagram ';

            let params_data = {
                merchant_account_id: this.$store.state.user_data.merchant_account_id,
                start_date: moment(this.start_date).format('YYYY-MM-DD'),
                end_date: moment(this.end_date).format('YYYY-MM-DD'),
                sort_key: this.top_post.sort.sort_key,
                sort_val: this.top_post.sort.sort_val,
                page: this.top_post.sort.page,
                per_page: this.top_post.sort.per_page,
                with_extra_count: '',
                social_platform: sp,
                brand_post_only: 1,
                social_post_type: this.handle_post_type(),//this.socisl_post_type,
            }

            if (this.selected_tags.length > 0) {
                params_data.tag_ids = this.selected_tags.map(e => { return e.id })
            }

            // Add creator tag filters
            if (this.selected_creator_tags && this.selected_creator_tags.length > 0) {
                params_data.creator_tag_ids = this.selected_creator_tags.map(tag => tag.id);
                params_data.operation_type = this.creator_tag_operation_type;
            }

            this.$ajax(`creator/get-social-account-posts`, {
                params: params_data,
                method: 'get',
            }).then(res => {
                let getV = res.data.data;

                if (is_next) {
                    this.top_post.data.push(...getV.social_posts.data);
                } else {
                    this.top_post.data = getV.social_posts.data;
                }

                this.top_post.loading = false;
                this.top_post.next_loading = false;

                const getCountForPostCategory = (field) => {
                    for (let item of res.data.data.social_post_category) {
                        if (item.social_post_category === field) {
                            return item.count;
                        }
                    }
                    return 0;
                }
                this.top_post.ig_menu[0].value = getCountForPostCategory('post');
                this.top_post.ig_menu[1].value = getCountForPostCategory('reel');
                this.top_post.ig_menu[2].value = getCountForPostCategory('story');
                this.is_end = getV.social_posts.last_page <= getV.social_posts.current_page;
            });
        },

        getStateData() {
            if (this.$store.state.user_data.merchant_account_id) {
                this.chart_loading = true;

                let params_data = {
                    merchant_account_id: this.$store.state.user_data.merchant_account_id,
                    start_date: this.start_date,
                    end_date: this.end_date,
                }

                if (this.selected_tags.length > 0) {
                    params_data.tag_ids = this.selected_tags.map(e => { return e.id })
                }

                // Add creator tag filters
                if (this.selected_creator_tags && this.selected_creator_tags.length > 0) {
                    params_data.creator_tag_ids = this.selected_creator_tags.map(tag => tag.id);
                    params_data.operation_type = this.creator_tag_operation_type;
                }

                if (this.now_tab === 1) {
                    params_data.social_platform = 'tikTok'
                } else if (this.now_tab === 2) {
                    params_data.social_platform = 'instagram'
                }


                this.$ajax(`creator/get-social-account-brand-content-posts-statistic`, {
                    params: params_data,
                    method: 'get',
                }).then(res => {
                    let vals = res.data.data.social_platform_stats;
                    const pushValue = (val, tk) => {
                        let arr = tk ? JSON.parse(JSON.stringify(this.top_post.tk_view_value)) : JSON.parse(JSON.stringify(this.top_post.ig_view_value));
                        arr.forEach(item => {
                            if (item.field === 'engagement_rate') {
                                item.value = HandleNumSpec(val[item.field]) !== '---' ? `${HandleNumSpec(val[item.field])}%` : HandleNumSpec(val[item.field]);
                            } else {
                                item.value = HandleNum(val[item.field]);
                            }

                        });
                        return arr;
                    }

                    this.chart_head1 = pushValue(vals[0].stats[0], 'tk');
                    this.chart_head2 = pushValue(vals[1].stats[0]);
                    this.chart_head3 = pushValue(vals[1].stats[1]);

                    this.tiktok_posts_count = vals[0].stats[0].total;
                    this.instagram_posts_count = vals[1].post_total;
                    this.instagram_feed_count = vals[1].stats[0].total;
                    this.story_count = vals[1].stats[1].total;
                    this.chart_loading = false;
                }).catch(err => {
                    console.log(err)
                })
            }

        },

        clickPost(v) {

        },

        selectTag(tag) {
            const index = this.selected_tags.findIndex((t) => t.id === tag.id);
            if (index === -1) {
                this.selected_tags.push(tag);
            } else {
                this.selected_tags.splice(index, 1);
            }

            this.callApi();
        },

        selectAll() {
            this.selected_tags = [];
            this.callApi();
        },

        callApi() {
            this.getStateData();
            this.getTop();
        },

        startFun() {
            if (this.$store.state.user_data.merchant_account_id) {
                // Prefer AnalyticsHeader's computed date_range (applies contract_start_time on /analytics/content)
                const header_range = this.$refs.analytics_header?.date_range;
                if (header_range?.start_date && header_range?.end_date) {
                    this.start_date = header_range.start_date;
                    this.end_date = header_range.end_date;
                } else if (this.$store.state.save_analytics_start_date && this.$store.state.save_analytics_end_date) {
                    this.start_date = this.$store.state.save_analytics_start_date;
                    this.end_date = this.$store.state.save_analytics_end_date;
                }

                let checkTime = handleMaxMinFun( this.start_date, this.end_date ,this);
                this.start_date = checkTime[0];
                this.end_date= checkTime[1];
                this.callApi();
            }
        },

        goSetting() {
            window.location.href = '/settings/content-listening';
        },

    },

    mounted() {
        if(!this.$store.state.user_data.permission_list.analytics.viewPerformanceSummaries.permission){
            this.$router.push('/creator/list');
            return;
        }
        // Initialize creator tags from store BEFORE startFun (so API calls include tags)
        if (this.$store.state.save_selected_tags && this.$store.state.save_selected_tags.length > 0) {
            this.selected_creator_tags = this.$store.state.save_selected_tags;
            this.creator_tag_operation_type = this.$store.state.save_tag_operation_type || 'or';
        }

        this.startFun();
        this.getTags();
        this.any_head_key+=1;
        this.$store.state.creator_data = null;
        this.top_post.top_menu_index = 0;
        this.top_post.ig_post_type = 0;
        this.EventBus.on('updated-all-post-tag', (tags) => {
            if (this.selected_tags) this.selected_tags.forEach((tag, tag_index) => {
                const index = tags.findIndex((o) => o.id === tag.id);
                if (index === -1) {
                    // remove this tag
                    //this.selected_tags.splice(tag_index, 1);
                    this.updateTag(tag);
                }
                this.getTop();
            });

            this.tags = tags;
        });

        this.EventBus.off('update-date');
        this.EventBus.on('update-date', (obj) => {
            this.start_date = obj.start_date;
            this.end_date = obj.end_date;
            setTimeout(() => {
                this.callApi();
            }, 100);
        });

        // Listen for creator tag updates
        this.EventBus.off('analytics-tags-updated');
        this.EventBus.on('analytics-tags-updated', (data) => {
            console.log('!analytics-tags-updated!', data);
            this.selected_creator_tags = data.tags;
            this.creator_tag_operation_type = data.operation_type;
            this.callApi();
        });

        // Add scroll listener for infinite scrolling
        this.$nextTick(() => {
            const scrollbarComponent = document.querySelector('#js-scrollbar-content');
            if (scrollbarComponent) {
                this.handleScroll = () => {
                    const scrollTop = scrollbarComponent.scrollTop;
                    const scrollHeight = scrollbarComponent.scrollHeight;
                    const clientHeight = scrollbarComponent.clientHeight;
                    
                    // Load next page when scrolled to 80% of content
                    if (scrollTop + clientHeight >= scrollHeight * 0.8) {
                        if (!this.is_end && !this.top_post.next_loading && !this.top_post.loading) {
                            this.getTop(true);
                        }
                    }
                };
                scrollbarComponent.addEventListener('scroll', this.handleScroll);
            }
        });

    },

    beforeUnmount() {
        // Clean up event listeners
        this.EventBus.off('update-date');
        this.EventBus.off('analytics-tags-updated');
        
        // Remove scroll listener
        const scrollbarComponent = this.$el?.querySelector?.('.ui-scrollbar__view');
        if (scrollbarComponent && this.handleScroll) {
            scrollbarComponent.removeEventListener('scroll', this.handleScroll);
        }
    },

}
</script>

<style lang="scss">
@mixin flexCenter() {
    display: flex;
    align-items: center;
}

.analytics-content {

    .inner {
        height: 100%;
        width: 100%;
        padding: 24px 48px; //24px 24px 0 24px;

        .sticker-big-box {
            @include flexCenter();
            justify-content: space-between;

            .tag-drop {
                margin-right: 24px;


                .edit-button {
                    margin: 6px 8px;
                }
            }
        }


        .head-info {
            display: block;
            margin: 0 0 16px;

            .title {
                margin: 0 0 16px;
                display: flex;
                align-items: center;

                h2 {
                    span {
                        font: var(--font-demi-20);
                        color: var(--black-90);
                        margin: 0;
                        flex: 1;
                        display: block;
                    }

                    p {
                        font-family: var(--font);
                        font-size: 12px;
                        color: var(--black-75);
                        margin: 0 0 8px;

                        &.small-text {
                            display: flex;
                        }

                        .link {
                            color: var(--blue);
                            cursor: pointer;
                        }
                    }
                }


            }

            .new-btn {
                position: relative;
                border-radius: 6px !important;
                height: 24px;
                width: 24px;
                padding: 0;
                margin-right: 8px;
                max-width: 24px;
                border: none;

                svg {
                    fill: white;
                    height: 12px;
                    width: 12px;
                    margin-right: 0;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                }
            }

            .update-time {
                display: flex;
                align-items: center;
                height: 32px;

                time {
                    font-size: 12px;
                    color: var(--black-75);
                    padding-right: 12px;
                }
            }

            .select-line {
                @include flexCenter();
                justify-content: space-between;

                .import-btn-box {
                    flex: 1;
                    @include flexCenter();
                    justify-content: flex-end;
                }

                .import-btn {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    color: white;
                    border-radius: 6px !important;
                    margin: 0 0 0 10px;
                    font: var(--font-med-12);

                    svg {
                        fill: white;
                        height: 10px;
                        width: 10px;
                        margin-right: 6px;
                    }
                }

                .select-tags {
                    display: inline-flex;
                    align-items: center;
                    margin: 0;
                    position: relative;

                    &.is-loading {
                        pointer-events: none;
                        opacity: 0.5;
                    }

                    &>h3 {
                        padding: 0 4px;
                        font: var(--font-med-12);
                        color: var(--black-90);
                    }

                    &>.tags {
                        display: flex;
                        align-items: center;
                        padding-right: 12px;

                        .ui-checkbox {
                            margin: 0 0 0 16px;
                            font: var(--font-med-12);
                            color: var(--black-90);

                            &:first-child {
                                margin-left: 2px;
                            }
                        }
                    }

                    &>.open-popup {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 24px;
                        height: 24px;
                        border-radius: 6px;
                        cursor: pointer;
                        margin-left: 8px;

                        svg {
                            fill: var(--black-90);
                            height: 14px;
                            width: 14px;
                        }

                        &:hover {
                            background-color: var(--bg-02);

                            svg {
                                fill: var(--dark-blue);

                            }
                        }
                    }

                    .dropdown-hashtag{
                        transform: unset !important;
                        right: 0;
                    }
                }
            }
        }

        .main {
            height: calc(100% - 120px);
            display: grid;
            //min-width: 1100px;
            border-radius: 8px;

            .top-brand-post-box {
                margin-bottom: 24px;
            }

            .left {
                min-width: 1100px; //600px;
                padding-bottom: 24px;
                overflow-x: hidden;

                .content-box {

                    .title {
                        padding: 4px 0;
                    }

                    .swiper-cus-box {
                        padding: 9px 12px;
                        background-color: var(--light-neutral);
                    }
                }

                .post-list-box {
                    display: grid;
                    grid-template-columns: repeat(4, 1fr);
                    gap: 8px;
                    overflow-x: hidden;
                    background-color: var(--light-neutral);
                    padding: 8px;
                    border-radius: 8px;

                    @media (max-width: 800px) {
                        grid-template-columns: repeat(3, 1fr);
                    }

                    .list-item {
                        overflow: hidden;
                    }
                }

            }

        }
    }
}
</style>